import React from "react";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import FilingForm from "../../../common/form/filing/FilingForm";

const LibservAdditionalDocStepFiling = () => {
  const libservAdditionalDocForm = useAppSelector((state) => {
    return state.Forms.LibservAdditionalDocForm;
  });

  return (
    <FilingForm
      basePath={baseEndpointPaths.libservAdditionalDoc}
      appId={libservAdditionalDocForm.id}
      allowedFileApplicationAction={false}
    />
  );
};
export default LibservAdditionalDocStepFiling;
